import { createContext, useContext, MutableRefObject } from "react";
import { TCustomCheckoutComponentItem, TCustomCheckoutLayout } from "../types/CustomCheckout";

/** Valores possíveis para drop em zonas fixas (topo/rodapé) */
export type TDropZoneTarget = "" | "top" | "bottom";

export interface ICheckoutBuilderContext {
  layout: TCustomCheckoutLayout;
  list: TCustomCheckoutComponentItem[];
  dragOverItem: MutableRefObject<string>;
  dragOverItemOld: MutableRefObject<string>;
  dropZoneTarget: MutableRefObject<TDropZoneTarget>;
  mouseEnterItemId: string;
  setList: (value: TCustomCheckoutComponentItem[]) => void;
  onEdit: (
    e:
      | React.MouseEvent<HTMLDivElement, MouseEvent>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.DragEvent<HTMLLIElement>,
    value: TCustomCheckoutComponentItem,
  ) => void;
  onDelete: (value: TCustomCheckoutComponentItem) => void;
  setMouseEnterItemId: React.Dispatch<React.SetStateAction<string>>;
  onDropItem: (e: React.DragEvent<HTMLDivElement>, dragItem: MutableRefObject<string>) => void;
}

const CheckoutBuilderContext = createContext<ICheckoutBuilderContext | null>(null);

export const useCheckoutBuilder = (): ICheckoutBuilderContext => {
  const context = useContext(CheckoutBuilderContext);
  if (!context) {
    throw new Error("useCheckoutBuilder deve ser usado dentro de um CheckoutBuilderProvider");
  }
  return context;
};

export default CheckoutBuilderContext;
